"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteWidget = void 0;
const command_manager_1 = require("../../command_manager");
const model_1 = require("../../model");
const store_1 = require("../../exports/store");
const types_1 = require("../../types");
exports.deleteWidget = {
    undoable: false,
    execute: (context, options) => {
        const { model: state } = context;
        const { widgetId, resourceId, resourceType } = options;
        const widgetPanels = store_1.Selectors.getResourceWidgetPanels(state, resourceId, resourceType);
        const activeWidgetPanel = store_1.Selectors.getResourceActiveWidgetPanel(state, resourceId, resourceType);
        if (!widgetPanels || !activeWidgetPanel) {
            return null;
        }
        const widgetPanelIndex = widgetPanels.findIndex(item => item.id === activeWidgetPanel.id);
        if (widgetPanelIndex < 0) {
            return null;
        }
        const widgets = activeWidgetPanel.widgets;
        const widgetIndex = widgets.findIndex(item => item.id === widgetId);
        if (widgetIndex < 0) {
            return null;
        }
        const deleteWidgetAction = resourceType === types_1.ResourceType.Datasheet ?
            model_1.DatasheetActions.deleteWidget2Action(state, { widgetPanelIndex, widget: widgets[widgetIndex], widgetIndex }) :
            model_1.DatasheetActions.deleteMirrorWidget2Action(state, { widgetPanelIndex, widget: widgets[widgetIndex], widgetIndex });
        return {
            result: command_manager_1.ExecuteResult.Success,
            resourceId: resourceId,
            resourceType: resourceType,
            actions: deleteWidgetAction,
        };
    },
};
//# sourceMappingURL=delete_widget.js.map